module.exports = __webpack_public_path__ + "static/media/NTUEworkshop-1128-00010.936fe466.JPG";